import { IconButton } from '@mui/material';

import { Iconify } from 'src/components/iconify';

type TSendButtonProps = {
  disabled?: boolean;
  onClick?: VoidFunction;
};

function SendButton({ disabled, onClick }: TSendButtonProps) {
  
  return (
    <IconButton
      data-testid="send-button"
      disabled={disabled}
      aria-label="send button"
      onClick={onClick}
    >
      <Iconify width={20} icon="iconamoon:send-fill" sx={{ color: !disabled ? 'primary.main' : 'text.disabled' }} />
    </IconButton>
  );
}

export default SendButton;
